import {
  Component,
  effect,
  input,
  output,
  signal,
  untracked,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OriInput } from '~/components/ui/input';

@Component({
  selector: 'editable-cell',
  imports: [FormsModule, OriInput],
  template: `
      <input
        [value]="modelValue()"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (click)="editing.set(false)"
        (keydown)="onKeydown($event)"
        type="text"
        oriInput
        variant="outline"
        class="h-6 w-full border-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 !outline-none"
      />
  `,
  standalone: true,
   
})
export class EditableCell {
  readonly modelValue = signal<unknown>(undefined);
  readonly value = input<unknown>();
  readonly blur = output<unknown>();
  readonly editing = signal(false);

  private initialValue: unknown = undefined;

  constructor() {
    effect(() => {
      const val = this.value();
      untracked(() => this.modelValue.set(val));
      this.initialValue = val;
    });
  }

  onInput(event: Event) {
    const target = event.target as HTMLInputElement;
    this.modelValue.set(target.value);
  }

  onBlur() {
    const currentValue = this.modelValue();

    if (currentValue !== this.initialValue) {
      this.blur.emit(currentValue);
    }
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const currentValue = this.modelValue();

      if (currentValue !== this.initialValue) {
        this.blur.emit(currentValue);
        this.initialValue = currentValue;
      }
      (event.target as HTMLElement).blur();
    }
  }
}
